import { render } from "./AkDropdownMultiple.vue?vue&type=template&id=afbfb308"
import script from "./AkDropdownMultiple.vue?vue&type=script&lang=js"
export * from "./AkDropdownMultiple.vue?vue&type=script&lang=js"

import "./AkDropdownMultiple.vue?vue&type=style&index=0&id=afbfb308&lang=css"

import exportComponent from "/root/dirif/preprod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__